import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const alertPoliciesRoute: InvariantJiraRoute = {
	name: 'eoc-team-policies',
	path: '/jira/ops/teams/:teamId/policies',
	exact: true,
};
